<template>
  <div class="AttendanceList">
    <HearderTitle name="考勤记录" />
    <div class="tableBox">
      <div class="tool_bar">
        <el-form :inline="true" :model="queryInfo">
          <el-form-item label="时间">
            <el-date-picker prefix-icon=" " v-model="queryInfo.time" type="month" placeholder="请选择" value-format="yyyy-MM"> </el-date-picker>
          </el-form-item>
          <el-form-item style="margin-left: -10px">
            <el-button class="lightBlueBtn searchBtn" type="primary" size="small" @click="search()">查询</el-button>
          </el-form-item>
          <el-form-item style="float: right; margin-right: 0">
            <el-button class="lightBlueBtn" type="primary" size="small">导入考勤记录</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table">
        <el-table ref="refTable" border header-cell-class-name="h_bg" :data="tableData" style="width: 100%">
          <el-table-column prop="" label="人员" width="80" align="center"> </el-table-column>
          <el-table-column prop="" label="时间" align="center"> </el-table-column>
          <el-table-column prop="" width="158" label="出勤" align="center"> </el-table-column>
          <el-table-column prop="" label="迟到" align="center"> </el-table-column>
          <el-table-column prop="" label="早退" align="center"> </el-table-column>
          <el-table-column prop="" label="请假" align="center"> </el-table-column>
          <el-table-column label="旷工" align="center"> </el-table-column>
          <el-table-column label="打卡记录" align="center"> </el-table-column>
        </el-table>
        <div class="pagination_box">
          <el-pagination @current-change="handleCurrentChange" :current-page="queryInfo.pageNum" :page-size="queryInfo.pageSize" layout="total, prev, pager, next,jumper" :total="total" background> </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import pageCacheMix from '@/mixins/pageCacheMix'
  import HearderTitle from '@/components/HearderTitle'
  export default {
    name: 'AttendanceList',
    mixins: [pageCacheMix],
    data() {
      return {
        queryInfo: {
          // 当前页
          pageNum: 1,
          // 每页数量
          pageSize: 14,
          time: '0',
        },
        tableData: [],
        total: 0,
      }
    },
    created() {},
    components: { HearderTitle },
    methods: {
      search() {},
      // 监听当前页码的变化
      handleCurrentChange(newpagenum) {
        this.queryInfo.pageNum = newpagenum
        this.getAttendanceList()
      },
    },
  }
</script>

<style lang="less">
  .AttendanceList {
    .table .el-table .el-table__cell {
      padding: 5px 0;
    }
    .tableBox {
      .select {
        color: #015293;
        font-size: 12px;
        cursor: pointer;
      }
      .tool_bar {
        padding-top: 18px;
        padding-bottom: 18px;
        font-size: 14px;
        color: #888;
        .el-form-item {
          margin-right: 20px;
          margin-bottom: 0;
          .el-input__inner {
            width: 220px;
            height: 32px;
          }
          .el-input__inner {
            padding-left: 10px;
          }
          .middle {
            padding: 0 10px;
          }
          .searchBtn {
            width: 82px;
          }
        }
      }
      .el-table {
        min-height: 685px;
        &::before {
          height: 0;
        }
      }
    }
  }
  .auditionDialog {
    .el-dialog__header {
      border-bottom: 1px solid #dcdfe6;
    }
    .el-dialog__body {
      padding-bottom: 0;
      overflow: hidden;
      .el-form-item {
        margin-bottom: 15px;
      }
    }
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner,
    .el-textarea__inner {
      width: 178px;
    }
    .el-input__inner {
      padding-left: 15px;
      width: 178px;
    }
    .searchBtn {
      width: 112px;
    }
  }
  .uploadDialog {
    .el-dialog__header {
      border-bottom: 1px solid #dcdfe6;
    }
    .el-form {
      .el-form-item {
        &:last-child {
          margin-bottom: 0;
          .el-button {
            float: right;
            width: 112px;
            height: 32px;
            padding: 0;
            text-align: center;
          }
        }
      }
    }
  }
</style>
